import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Ripple from 'vue-ripple-directive'

import { fb, auth, db, timestamp, storage } from './firebase'
fb.analytics().setAnalyticsCollectionEnabled(false) // disable analytics until user accepts cookies

// Vue.use(firestorePlugin)
Vue.use(require('vue-cookies'))
Vue.config.productionTip = true
Ripple.color = 'rgba(160, 160, 160, 0.12)'
Vue.directive('ripple', Ripple)

var store = {
  state: {
    strg: storage,
    version: 1.0, // current clickzip version
    loggedIn: false, // overall login state
    fbAuth: auth, // check changes here
    currentUser: { // place to store user data globaly
      // loggedIn: false,
      uid: null,
      verified: null,
      newsletter: false,
      userData: {
        mail: 'user@clickzip.de',
        companyName: 'Firmenname',
        companyLegal: 'GmbH',
        userName: 'Max Mustermann',
        addressStreet: 'Musterstraße',
        addressZip: '99999',
        addressLocation: 'Musterstadt',
        addressAddition: ''
      },
      configurations: [] // configurations from firestore will be stored here
    },
    saveWaiting: false, // add config but not logged in -> remember to save after login
    unsubscribeConfigs: null, // variable to store unsubscribe real time updates to firebase
    configsUpdated: false, // mutated each time configurations are reloaded from fb -> triggers sort function in component
    cookieBanner: true,
    cookieAccepted: false,
    cookieDenied: false,
    resizeHandler: true, // toggled on sidedrawer toggle click; used as a computed property to update swiper to prevent resize bug
    collection: [], // collected templates
    items: [
      /* Monatszahlung */
      { id: 'monatszahlung', name: 'Monatszahlung', status: false },
      /* Basics */
      { id: 'pages', name: 'Page-Templates', status: false, amount: 0 },
      { id: 'suchfunktion', name: 'Suchfunktion', status: false },
      /* Sprachen */
      { id: 'mehrsprachigkeit', name: 'Mehrsprachigkeit', status: false },
      { id: 'sprachen', name: 'Anzahl der Sprachen', status: false, amount: 0 },
      { id: 'bidirektional', name: 'Bidirektionaler Text', status: false },
      /* Funktionen */
      { id: 'terminkalender', name: 'Terminkalender', status: false },
      { id: 'kontaktformular', name: 'Kontaktformular', status: false },
      { id: 'newsletter', name: 'Newsletter', status: false },
      { id: 'bildergalerie', name: 'Bildergalerien', status: false },
      { id: 'antispam', name: 'Anti-Spam Plugin', status: false },
      { id: 'cookies', name: 'Cookie-Hinweis', status: false },
      { id: 'googlemaps', name: 'Google Maps', status: false },
      { id: 'googleanalytics', name: 'Google Analytics', status: false },
      /* Blog */
      { id: 'blogfunktion', name: 'Blog', status: false },
      { id: 'kommentare', name: 'Kommentarfunktion', status: false },
      { id: 'share', name: 'Teilen-Buttons', status: false },
      { id: 'videoposts', name: 'Video-Posts', status: false },
      /* Online Shop */
      { id: 'onlineshop', name: 'Online Shop', status: false },
      { id: 'produktoptionen', name: 'Produktoptionen', status: false },
      { id: 'produktfilter', name: 'Produktfilter', status: false },
      { id: 'downloadprodukte', name: 'Produkt-Downloads', status: false },
      { id: 'affiliate', name: 'Amazon Affiliate', status: false },
      { id: 'sociallogin', name: 'Login über Dritte', status: false },
      { id: 'paymentmethods', name: 'Zahlungsmethoden', status: false },
      /* Services */
      { id: 'livecoding', name: 'Live-Entwicklung', status: false },
      { id: 'schulung', name: 'Schulung', status: false },
      { id: 'content', name: 'Anzahl der einzupflegenden Seiten', status: false, amount: 0 },
      { id: 'datensicherung', name: 'Datensicherung', status: false },
      { id: 'updates', name: 'Updates', status: false },
      /* Technisches */
      { id: 'parallax', name: 'Parallax-Effekte', status: false },
      { id: 'compantibily', name: 'Kompatibilität', status: false },
      { id: 'spa', name: 'SPA', status: false },
      { id: 'aria', name: 'Aria-Labels', status: false },
      { id: 'socialtags', name: 'Social-Tags', status: false }
    ],
    priceList: [
      /* Monatszahlung */
      { id: 'monatszahlung', kind: 'modifier', price: 1.1 },
      /* Grundlagen */
      { id: 'pages', kind: 'amount', price: 236 },
      { id: 'suchfunktion', kind: 'flat', price: 177 },
      /* Funkttionen */
      { id: 'terminkalender', kind: 'flat', price: 384 },
      { id: 'kontaktformular', kind: 'flat', price: 177 },
      { id: 'newsletter', kind: 'flat', price: 635 },
      { id: 'bildergalerie', kind: 'flat', price: 118 },
      { id: 'antispam', kind: 'flat', price: 59 },
      { id: 'cookies', kind: 'flat', price: 59 },
      { id: 'googlemaps', kind: 'flat', price: 118 },
      { id: 'googleanalytics', kind: 'flat', price: 59 },
      /* Services */
      { id: 'livecoding', kind: 'flat', price: 118 },
      { id: 'schulung', kind: 'flat', price: 118 },
      { id: 'content', kind: 'amount', price: 29.5 },
      { id: 'datensicherung', kind: 'flat', price: 236 },
      { id: 'updates', kind: 'flat', price: 236 },
      /* Blog */
      { id: 'blogfunktion', kind: 'flat', price: 177 },
      { id: 'kommentare', kind: 'flat', price: 118 },
      { id: 'share', kind: 'flat', price: 59 },
      { id: 'videoposts', kind: 'flat', price: 118 },
      /* Online Shop */
      { id: 'onlineshop', kind: 'flat', price: 472 },
      { id: 'produktoptionen', kind: 'flat', price: 267 },
      { id: 'produktfilter', kind: 'flat', price: 267 },
      { id: 'downloadprodukte', kind: 'flat', price: 59 },
      { id: 'affiliate', kind: 'flat', price: 326 },
      { id: 'sociallogin', kind: 'flat', price: 149 },
      { id: 'paymentmethods', kind: 'flat', price: 149 },
      /* Sprachen */
      { id: 'mehrsprachigkeit', kind: 'modifier', price: 1.1 },
      { id: 'sprachen', kind: 'amount', price: 59 },
      { id: 'bidirektional', kind: 'modifier', price: 1.3 },
      /* ? */
      { id: 'parallax', kind: 'flat', price: 472 },
      { id: 'compantibily', kind: 'flat', price: 960 },
      { id: 'spa', kind: 'flat', price: 944 },
      { id: 'aria', kind: 'flat', price: 236 },
      { id: 'socialtags', kind: 'flat', price: 59 }
    ]
  }
}

new Vue({
  router,
  render: h => h(App),
  data: store.state,
  methods: {
    getItemByID: function (ID) {
      return this.items.find(item => item.id === ID)
    },
    resetItemStates: function () {
      // reset each saved item
      for (var x = 0; x < this.items.length; x++) {
        this.items[x].status = false
        if (this.items[x].amount !== null) {
          this.items[x].amount = 0
        }
      }
      // reset templates
      this.collection = []
    },
    /***********************************************************/
    /* Firebase ************************************************/
    /***********************************************************/
    /*
    uploadFile: function () {
      let storageRef = storage.ref()
      let path = storageRef.child('fischi')
      let file = ''
      path.put(file).then(function (snapshot) {
        console.log('Uploaded a blob or file!')
      })
    },
    */
    addConfiguration: function () {
      db.collection('configurations').add({
        user: this.currentUser.uid,
        configuration: this.items,
        prices: this.priceList,
        status: 0,
        creationDate: timestamp,
        clickzipVersion: this.version,
        total: this.totalOutput,
        name: 'Neues Projekt'
      }).then(x => {
        this.resetItemStates()
        this.saveWaiting = false // no more config is waiting for being saved
        console.log('Configuration successfully written.')
      }).catch(function (error) {
        console.error('Error writing configuration: ', error)
      })
    },
    deleteConfiguration: function (docId) {
      db.collection('configurations').doc(docId).delete().then(x => {
        console.log('Dokument gelöscht')
      }).catch(error => {
        console.error('error: ', error)
      })
    },
    updateConfigurationName: function (configId, newName) {
      db.collection('configurations').doc(configId).update({
        name: newName
      }).then(function () {
        console.log('Document successfully updated!')
      }).catch(function (error) {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error)
      })
    },
    loadConfigurationsRealtime: function () {
      this.unsubscribeConfigs = db.collection('configurations').where('user', '==', this.currentUser.uid).onSnapshot(querySnapshot => {
        this.currentUser.configurations = []
        querySnapshot.forEach(doc => {
          let obj = doc.data()
          obj.id = doc.id
          this.currentUser.configurations.push(obj)
        })
        this.configsUpdated = !this.configsUpdated
      })
    },
    loadConfigurationsOnce: function () {
      db.collection('configurations').where('user', '==', this.currentUser.uid).get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.currentUser.configurations = []
          this.currentUser.configurations.push(doc.data())
        })
      }).catch(error => {
        console.log('Error getting documents: ', error)
      })
    },
    loadProfile: function () {
      db.collection('users').doc(this.currentUser.uid).get().then(doc => {
        if (doc.exists) {
          this.currentUser.userData = doc.data()
        } else {
          console.warn('User existiert nicht')
        }
      }).catch(error => {
        console.error('Error: ', error)
      })
    },
    /*
    updateProfile: function (key, value) {
      db.collection('users').doc(this.currentUser.uid).update({
        [key]: value
      }).then(none => {
        // this.loadProfile()
        console.log('Document successfully updated!')
      }).catch(error => {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error)
      })
    },
    */
    updateProfile: function (newData) {
      db.collection('users').doc(this.currentUser.uid).update({
        companyName: newData.companyName,
        companyLegal: newData.companyLegal,
        userName: newData.userName,
        addressStreet: newData.addressStreet,
        addressZip: newData.addressZip,
        addressLocation: newData.addressLocation,
        addressAddition: newData.addressAddition,
        newsletter: newData.newsletter,
        phone: newData.phone
      }).then(none => {
        console.log('Document successfully updated!')
      }).catch(error => {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error.code, ': ', error.message)
      })
    },
    setNewPassword: function (oldPassword, newPassword) {
      auth.signInWithEmailAndPassword(this.currentUser.userData.mail, oldPassword).then(user => {
        // Sign in success
        auth.currentUser.updatePassword(newPassword).then(x => {
          // Update successful.
          alert('Passwort erfolgreich geändert. Sie können sich ab sofort mit Ihrem neuen Passwort einloggen.')
        }).catch(error => {
          // update password error
          alert('Passwort konnte nicht geändert werden.')
          console.error(error.code)
        })
      }).catch(error => {
        // Sign in error
        console.error(error.code + ': ' + error.message)
        if (error.code === 'auth/wrong-password') {
          alert('Altes Passwort falsch.')
        } else if (error.code === 'auth/too-many-requests') {
          alert('Zu viele fehlerhafte Versuche. Bitte versuchen Sie es später erneut.')
        } else {
          alert('Unbekannter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.')
        }
      })
    },
    setNewMail: function (newMail) {
      auth.currentUser.updateEmail(newMail).then(x => {
        alert('Mail-Adresse erfolgreich geändert.')
        this.email = newMail
        // Update successful.
      }).catch(error => {
        this.mailChange = ''
        console.warn(error)
        alert('Änderung nicht möglich. Bitte überprüfen Sie die eingegebene E-Mail-Adresse und wenden Sie sich gegebenenfalls an den Support.')
        // An error happened.
      })
    },
    signOut: function () {
      auth.signOut().then(x => {
        this.unsubscribeConfigs() // unsubscribe from realtime firestore updates
        this.currentUser.configurations = [] // delete donwloaded configs
        this.loggedIn = false
        // this.currentUser.loggedIn = false
        this.currentUser.uid = null
        this.currentUser.verified = null
        this.currentUser.userData.mail = 'user@clickzip.de'
        this.currentUser.userData.companyName = 'Firmenname'
        this.currentUser.userData.companyLegal = 'GmbH'
        this.currentUser.userData.userName = 'Max Mustermann'
        this.currentUser.userData.addressStreet = 'Musterstraße'
        this.currentUser.userData.addressZip = '99999'
        this.currentUser.userData.addressLocation = 'Musterstadt'
        this.currentUser.userData.addressAddition = ''
        this.currentUser.userData.newsletter = false
      }).catch(function (error) {
        console.error(error)
      })
    },
    sendVerificationMail: function () {
      if (!this.currentUser.verified) {
        auth.currentUser.sendEmailVerification().then(function () {
          // Email sent.
          alert('Bestätigungs-Mail gesendet. Bitte überprüfen Sie auch Ihren Spam-Ordner.')
        }).catch(function (error) {
          // An error happened.
          console.error('Error while sending verification!', error.code)
          alert('Bestätigungs-Mail konnte nicht gesendet werden. Bitte wenden Sie sich an den Support.')
        })
      }
    }
  },
  computed: {
    selectedItems: function () {
      return this.items.filter(function (item) {
        return item.status === true
      })
    },
    selectedIDs: function () {
      return this.selectedItems.map(function (item) {
        return item.id
      })
    },
    selectedPrices: function () {
      return this.priceList.filter(obj => this.selectedIDs.includes(obj.id))
    },
    selectedModifiers: function () {
      return this.selectedPrices.filter(price => price.kind.includes('modifier'))
    },
    selectedFlats: function () {
      return this.selectedPrices.filter(price => price.kind.includes('flat'))
    },
    selectedAmounts: function () {
      return this.selectedPrices.filter(price => price.kind.includes('amount'))
    },
    flatTotal: function () {
      if (this.selectedFlats.length === 0) {
        return 0
      } else {
        return this.selectedFlats.map(item => parseInt(item.price)).reduce((total, amount) => total + amount)
      }
    },
    modifiedTotal: function () {
      if (this.selectedModifiers.length === 0) {
        return 1
      } else {
        return this.selectedModifiers.map(item => parseFloat(item.price)).reduce((total, amount) => total * amount)
      }
    },
    amountTotal: function () {
      if (this.selectedAmounts.length === 0) {
        return 0
      } else {
        var x = 0
        for (var amountItem of this.selectedAmounts) {
          x = x + amountItem.price * this.items.find(item => item.id === amountItem.id).amount
        }
        return x
      }
    },
    total: function () {
      return (this.amountTotal + this.flatTotal) * this.modifiedTotal
    },
    totalMonthly: function () {
      return this.total / 24
    },
    totalOutput: function () {
      if (this.getItemByID('monatszahlung').status === false) { // wenn monatlich nicht ausgewählt
        return Math.round(this.total * 1) / 1 // runde und gebe das totale aus
      } else { // wenn monatlich ausgewählt
        return Math.round(this.totalMonthly * 1) / 1 // runde und gebe das totale monatliche aus
      }
    },
    monthlyPaymentSelected: function () {
      return this.getItemByID('monatszahlung').status
    }
  },
  mounted: function () {
    if (this.$cookies.isKey('permission_cookie')) { // cookie bereits vorhanden
      if (this.$cookies.get('permission_cookie') === 'allow') { // cookie sagt ja
        fb.analytics().setAnalyticsCollectionEnabled(true)
        fb.analytics().logEvent('cookie_accepted_before')
        this.cookieAccepted = true
        this.cookieBanner = false
      } // else { cookie sagt nein }
    }
  },
  watch: {
    cookieAccepted: function (accepted) {
      if (accepted) {
        this.cookieBanner = false
        this.$cookies.set('permission_cookie', 'allow', 30 * 60 * 60 * 24) // 14 Tage gültig
        fb.analytics().setAnalyticsCollectionEnabled(true)
        fb.analytics().logEvent('cookie_accepted')
      }
    },
    cookieDenied: function (denied) {
      if (denied) {
        this.cookieBanner = false
      }
    },
    // Firebase Firestore //
    fbAuth: {
      immediate: true,
      deep: true,
      handler: function (content) {
        if (content.currentUser !== null) {
          this.loggedIn = true
        }
      }
    },
    loggedIn: function (val) {
      if (val) {
        this.currentUser.uid = auth.currentUser.uid
        this.currentUser.verified = auth.currentUser.emailVerified
        this.loadProfile()
        this.loadConfigurationsRealtime()
      }
    }
    /*
    userData: { // TODO
      immediate: true,
      deep: true,
      handler: function (userData) {
        if (this.user === null) {
          if (userData.companyName === '') {
            userData.companyName = 'Firmenname mit Rechtsform'
          }
          if (userData.userName === '') {
            userData.userName = 'Vollständiger Name'
          }
          if (userData.addressStreet === '') {
            userData.addressStreet = 'Straße und Hausnummer'
          }
          if (userData.addressZip === '') {
            userData.addressZip = 'Postleitzahl'
          }
          if (userData.addressLocation === '') {
            userData.addressLocation = 'Ort'
          }
          if (userData.addressAddition === '') {
            userData.addressAddition = 'Adresszusatz'
          }
        }
      }
    }
    */
  }
}).$mount('#app')
